import 'css-chunksrc/client/scenes/wbs/task/allocationsList/details/allocation/completion/completionInput/styles.scss';export default {
  "completionInput": "_completionInput_1mgy5_1",
  "edition": "_edition_1mgy5_7",
  "input": "_input_1mgy5_11",
  "text": "_text_1mgy5_31"
};